export default [
    "24 24",
    '<path d="M20 18H10M20 14H4M20 10H10M20 6H4" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
]

